import React from "react";
import { useGetA2pRegistrationQuery } from "@/store/rest_api";
import { Skeleton } from "@/components/ui/skeleton";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { A2pRegistrationStatus } from "@/model/interface/A2pRegistration";
import BusinessInfoStep from "./BusinessInfoStep";
import BrandReviewStep from "./BrandReviewStep";
import CampaignSetupStep from "./CampaignSetupStep";
import PhoneNumbersStep from "./PhoneNumbersStep";
import RegistrationStatusStep from "./RegistrationStatusStep";
import StepIndicator from "./StepIndicator";

const STATUS_TO_STEP: Record<A2pRegistrationStatus, number> = {
  NOT_STARTED: 1,
  PLATFORM_REVIEW: 2,
  PLATFORM_REJECTED: 1,
  PROFILE_PENDING: 2,
  PROFILE_APPROVED: 2,
  PROFILE_REJECTED: 2,
  BRAND_PENDING: 3,
  BRAND_APPROVED: 3,
  BRAND_FAILED: 3,
  CAMPAIGN_PENDING: 4,
  CAMPAIGN_FAILED: 4,
  COMPLETED: 5,
  CANCELLED: 5,
};

const STEPS = [
  { label: "Business Info", description: "Company details" },
  { label: "Brand Registration", description: "Verify your brand" },
  { label: "Campaign Setup", description: "Configure messaging" },
  { label: "Phone Numbers", description: "Assign numbers" },
  { label: "Complete", description: "Registration status" },
];

export default function A2pRegistrationWizard() {
  const { data: registration, isLoading } = useGetA2pRegistrationQuery();

  if (isLoading) return <Skeleton className="h-96 w-full" />;

  const currentStep = registration ? STATUS_TO_STEP[registration.status] : 1;

  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle>A2P 10DLC Registration</CardTitle>
          <CardDescription>
            Register your business for A2P 10DLC messaging to send SMS from your purchased phone numbers.
            This is required by US carriers for business SMS.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <StepIndicator steps={STEPS} currentStep={currentStep} />
        </CardContent>
      </Card>

      {currentStep === 1 && <BusinessInfoStep registration={registration ?? null} />}
      {currentStep === 2 && registration && <BrandReviewStep registration={registration} />}
      {currentStep === 3 && registration && <CampaignSetupStep registration={registration} />}
      {currentStep === 4 && registration && <PhoneNumbersStep registration={registration} />}
      {currentStep === 5 && registration && <RegistrationStatusStep registration={registration} />}
    </div>
  );
}
